const DEFAULT_ZERO_POINT_RADIUS = 10;
const DEFAULT_ZERO_POINT_COLOR = "#dddddd";
const DEFAULT_VECTOR_SNAP_TO_GIRD = true;

const DEFAULT_LATEX_SYMBOL = 0; // Zero Vector
const DEFAULT_LATEX_SYMBOL_SIZE = 25;

export {
    DEFAULT_ZERO_POINT_RADIUS,
    DEFAULT_ZERO_POINT_COLOR,
    DEFAULT_VECTOR_SNAP_TO_GIRD,

    DEFAULT_LATEX_SYMBOL,
    DEFAULT_LATEX_SYMBOL_SIZE
};

export const SymbolType = Object.freeze({
    IN_PLANE: 0,
    SOLID_DOT: 1,
    OUT_ODOT: 2,
    IN_OTIMES: 3,
});